import styled from 'styled-components';

export const Clearfix = styled.div`
  &::before,
  &::after {
    content: '';
    display: table;
  }
`;
